import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=2b2a369a"
var script = {}
import style0 from "./spinner.vue?vue&type=style&index=0&id=2b2a369a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports